class UseAnimate extends HTMLElement {
  constructor() {
    super();
    if(!window.appearAnimate) return;
    this.inited = false;
  }

  connectedCallback() {
    if(window.innerWidth >= 750) {
      this.createObserver();
    } else {
      animateResizeObserver.observe(this);
    }
  }

  createObserver() {
    this.inited = true;
    animateObserver.observe(this);
  }

  showImages() {
    this.classList.add('loaded');
  }
}

customElements.define('use-animate', UseAnimate);

if (!customElements.get('before-after-image-slider')) {
  customElements.define('before-after-image-slider', class BeforeAfterImageSlider extends HTMLElement {
    constructor() {
      super();
      this.range = this.querySelector('.ba-image-slider__drag-slider');
    }

    connectedCallback() {
      this.onRangeChangeHandler = this.onRangeChange.bind(this);
      this.range.addEventListener('input', this.onRangeChangeHandler);
      
      this.onTouchStartHandler = this.onTouchStart.bind(this);
      this.addEventListener('touchstart', onTouchStartHandler, { passive: false });
    }

    disconnectedCallback() {
      this.range.removeEventListener('input', this.onRangeChangeHandler);
    }

    onTouchStart(event) {
      event.stopPropagation();
    }

    onRangeChange(e) {
      this.style.setProperty('--drag-position', `${e.target.value}%`);
    }
  })
}